import React, { useEffect, useState } from 'react'

import styles from './service-fee.module.scss'
import { filterOptionSelect, formatCash } from 'utils'

//antd
import {
  Form,
  Table,
  Button,
  Modal,
  InputNumber,
  Row,
  Space,
  Select,
  notification,
  Popconfirm,
  Col,
} from 'antd'
import { DeleteOutlined } from '@ant-design/icons'

//apis
import { getBranches } from 'apis/branch'
import { getCountries } from 'apis/country'
import { getRegions } from 'apis/region'
import { getServiceFee, addServiceFee, updateServiceFee, deleteServiceFee } from 'apis/tax'

//components
import TitlePage from 'components/title-page'
import FilterRegion from 'components/filter-region'

export default function Employee() {
  const [form] = Form.useForm()

  const [serviceFeeList, setServiceFeeList] = useState([])
  const [countServiceFee, setCountServiceFee] = useState([])
  const [branches, setBranches] = useState([])
  const [regions, setRegions] = useState([])
  const [countries, setCountries] = useState([])
  const [loading, setLoading] = useState(false)
  const [paramsFilter, setParamsFilter] = useState({ page: 1, page_size: 20 })

  const _getBranches = async () => {
    try {
      const res = await getBranches()
      if (res.status === 200) setBranches(res.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  const _getCountries = async () => {
    try {
      const res = await getCountries()
      if (res.status === 200) setCountries(res.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  const _getRegions = async () => {
    try {
      const res = await getRegions()
      if (res.status === 200) setRegions(res.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  const _deleteServiceFee = async (id) => {
    try {
      const res = await deleteServiceFee({ service_fee_id: [id] })
      if (res.status === 200) {
        if (res.data.success) {
          notification.success({ message: 'Xóa phí dịch vụ thành công' })
          _getServiceFee()
        } else notification.error({ message: 'Xóa phí dịch vụ thất bại, vui lòng thử lại' })
      } else notification.error({ message: 'Xóa phí dịch vụ thất bại, vui lòng thử lại' })
    } catch (error) {
      console.log(error)
    }
  }

  const columnsServiceFee = [
    {
      title: 'STT',
      render: (text, record, index) => (paramsFilter.page - 1) * paramsFilter.page_size + index + 1,
    },
    {
      title: 'Mã',
      dataIndex: 'code',
    },
    {
      title: 'Giá trị',
      render: (text, record) => record.value && formatCash(record.value || 0),
    },
    {
      title: 'Thuế',
      render: (text, record) => record.tax && formatCash(record.tax || 0),
    },
    {
      title: 'Quốc gia',
      render: (text, record) => record.country_info && record.country_info.name,
    },
    {
      title: 'Khu vực',
      render: (text, record) => record.region_info && record.region_info.name,
    },
    // {
    //   title: 'Chi nhánh',
    //   render: (text, record) => record.branch_info && record.branch_info.name,
    // },
    {
      title: '',
      render: (text, record) => (
        <Space>
          <ModalAddOrUpdateServiceFee record={record} />
          <Popconfirm
            onConfirm={() => _deleteServiceFee(record.service_fee_id)}
            title="Bạn có muốn xóa phí dịch vụ này không?"
          >
            <Button type="primary" danger icon={<DeleteOutlined />} size="large" />
          </Popconfirm>
        </Space>
      ),
    },
  ]

  const _getServiceFee = async () => {
    try {
      setLoading(true)
      const res = await getServiceFee(paramsFilter)
      console.log(res)
      if (res.status === 200) {
        setServiceFeeList(res.data.data)
        setCountServiceFee(res.data.count)
      }
      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  const ModalAddOrUpdateServiceFee = ({ record }) => {
    const [visible, setVisible] = useState(false)
    const toggle = () => setVisible(!visible)
    const [loading, setLoading] = useState(false)

    const _addOrUpdateServiceFee = async () => {
      try {
        await form.validateFields()
        const body = form.getFieldsValue()
        setLoading(true)
        let res
        if (record) res = await updateServiceFee(body, record.service_fee_id)
        else res = await addServiceFee(body)
        setLoading(false)
        console.log(res)
        if (res.status === 200) {
          if (res.data.success) {
            notification.success({
              message: `${record ? 'Cập nhật' : 'Tạo'} phí dịch vụ thành công`,
            })
            _getServiceFee()
          } else
            notification.error({
              message: `${record ? 'Cập nhật' : 'Tạo'} phí dịch vụ thất bại, vui lòng thử lại`,
            })
        } else
          notification.error({
            message: `${record ? 'Cập nhật' : 'Tạo'} phí dịch vụ thất bại, vui lòng thử lại`,
          })
      } catch (error) {
        setLoading(false)
        console.log(error)
      }
    }

    useEffect(() => {
      if (!visible) form.resetFields()
      else form.setFieldsValue({ ...record })
    }, [visible])

    return (
      <>
        <Button type="primary" size="large" onClick={toggle}>
          {record ? 'Cập nhật' : 'Tạo phí dịch vụ'}
        </Button>

        <Modal
          footer={
            <Row justify="end">
              <Space>
                <Button onClick={toggle}>Đóng</Button>
                <Button onClick={_addOrUpdateServiceFee} loading={loading} type="primary">
                  {record ? 'Cập nhật' : 'Tạo'}
                </Button>
              </Space>
            </Row>
          }
          title={`${record ? 'Cập nhật' : 'Tạo'} phí dịch vụ`}
          onCancel={toggle}
          visible={visible}
        >
          <Form form={form} layout="vertical">
            <Form.Item
              name="value"
              label="Giá trị"
              rules={[{ required: true, message: 'Vui lòng nhập giá trị' }]}
            >
              <InputNumber
                style={{ width: '100%' }}
                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                min={0}
                placeholder="Nhập giá trị"
              />
            </Form.Item>

       
            <Form.Item
              name="tax"
              label="Giá trị thuế"
              rules={[{ required: true, message: 'Vui lòng nhập giá trị' }]}
            >
              <InputNumber
                style={{ width: '100%' }}
                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                min={0}
                placeholder="Nhập thuế"
              />
            </Form.Item>

            <Form.Item
              name="country_id"
              label="Quốc gia"
              rules={[{ required: true, message: 'Vui lòng chọn quốc gia' }]}
            >
              <Select
                filterOption={filterOptionSelect}
                placeholder="Chọn quốc gia"
                optionFilterProp="children"
                showSearch
              >
                {countries.map((country, index) => (
                  <Select.Option value={country.country_id} key={index}>
                    {country.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="region_id"
              label="Khu vực"
              rules={[{ required: true, message: 'Vui lòng chọn khu vực' }]}
            >
              <Select
                filterOption={filterOptionSelect}
                placeholder="Chọn khu vực"
                optionFilterProp="children"
                showSearch
                // mode={'multiple'}
              >
                {regions.map((region, index) => (
                  <Select.Option value={region.region_id} key={index}>
                    {region.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            {/* <Form.Item
              name="branch_id"
              label="Chi nhánh"
              rules={[{ required: true, message: 'Vui lòng chọn chi nhánh' }]}
            >
              <Select
                filterOption={filterOptionSelect}
                placeholder="Chọn chi nhánh"
                optionFilterProp="children"
                showSearch
              >
                {branches.map((branch, index) => (
                  <Select.Option value={branch.branch_id} key={index}>
                    {branch.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item> */}
          </Form>
        </Modal>
      </>
    )
  }

  useEffect(() => {
    _getBranches()
    _getCountries()
    _getRegions()
  }, [])

  useEffect(() => {
    _getServiceFee()
  }, [paramsFilter])

  return (
    <div className={`${styles['promotion_manager']} ${styles['card']}`}>
      <TitlePage title="Quản lý phí dịch vụ">
        <ModalAddOrUpdateServiceFee />
      </TitlePage>

      <Row gutter={[16, 16]} style={{ marginTop: 10 }}>
        <Col xs={24} sm={24} md={24} lg={10} xl={10}>
          <FilterRegion
            width_size={'100%'}
            setParamsFilter={setParamsFilter}
            paramsFilter={paramsFilter}
          />
        </Col>
      </Row>

      <Table
        loading={loading}
        rowKey="user_id"
        size="small"
        pagination={{
          position: ['bottomLeft'],
          current: paramsFilter.page,
          pageSize: paramsFilter.page_size,
          pageSizeOptions: [20, 30, 40, 50, 60, 70, 80, 90, 100],
          showQuickJumper: true,
          onChange: (page, pageSize) =>
            setParamsFilter({ ...paramsFilter, page: page, page_size: pageSize }),
          total: countServiceFee,
        }}
        columns={columnsServiceFee}
        dataSource={serviceFeeList}
        style={{ width: '100%', marginTop: 20 }}
      />
    </div>
  )
}
